






import { computed, defineComponent, PropType } from 'vue-demi';
import { CouponInfo } from '../../../../type';
import { CardInfo } from '../../type';
import CouponItem from '../../../coupon-item/index.vue';

export default defineComponent({
  name: 'MallCouponCard',
  components: {
    CouponItem,
  },
  emits: ['btnClick'],
  props: {
    data: {
      type: Object as PropType<CouponInfo & CardInfo>,
      required: true,
    },
  },
  setup(props, context) {
    const couponInfo = computed(() => props.data as CouponInfo);

    return {
      couponInfo,
    };
  },
});
